export default __webpack_public_path__ + "static/media/cir-select-chk.94af7162.svg";